import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, Typography } from '@mui/material';

import { timePeriodNames } from '~/util/storeRankingFilters';
import FilterIcon from '../FilterIcon';
import RankingListTopPanel from '../RankingListTopPanel';

import * as Style from './styles';

function StoreRankingHeader({
    orderBy,
    orderByAsc,
    setOrderAsc,
    channelFilter,
    setChannelFilterDialogIsOpen,
    setRankingData,
    totalValue,
}) {
    const { period } = useSelector(state => state.status);
    const selectedTimePeriod = timePeriodNames[period];

    return (
        <>
            <Style.TitleContainer>
                <Typography
                    style={{
                        fontWeight: 600,
                        fontSize: '20px',
                    }}
                >
                    Ranking do {selectedTimePeriod}
                </Typography>

                <FilterIcon
                    channelFilter={channelFilter}
                    setChannelFilterDialogIsOpen={setChannelFilterDialogIsOpen}
                />
            </Style.TitleContainer>

            <Style.TotalValueContainer container>
                <Grid item xs={6}>
                    <Style.TitleTypography subtitle>
                        Total:
                    </Style.TitleTypography>
                </Grid>

                <Grid item xs={6} style={{ textAlign: 'right' }}>
                    <Style.TitleTypography
                        subtitle
                        negativeValue={String(totalValue).includes('-')}
                        valueText
                    >
                        {totalValue}
                    </Style.TitleTypography>
                </Grid>
            </Style.TotalValueContainer>

            <RankingListTopPanel
                orderBy={orderBy}
                orderByAsc={orderByAsc}
                setOrderAsc={setOrderAsc}
                setRankingData={setRankingData}
            />
        </>
    );
}

export default StoreRankingHeader;
